import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 

import { HeadingBlockFullWidthComponent } from './heading-block-fullwidth.component'; 

@NgModule({
  declarations: [HeadingBlockFullWidthComponent],
  exports: [HeadingBlockFullWidthComponent],
  imports: [
    CommonModule, 
  ]
})
export class HeadingBlockFullWidthModule {}
